import React from 'react'
import { useTranslation } from 'react-i18next'

export interface DiscountProps {
  todaysTotal: number
  discountAmount: number
}

const DiscountComponent: React.FC<DiscountProps> = ({ todaysTotal, discountAmount }) => {
  const { t: translate } = useTranslation()

  return (
    <div className="inner-padding border-bottom">
      <div>
        <p className="inline pt-16">{translate('admin-signup.subscription.payment.subtotal-label')}</p>
        <span className="float-right">${todaysTotal}</span>
      </div>

      <div className="pt-16">
        <p className="inline">{translate('admin-signup.subscription.payment.fee-discount-label')}</p>
        <span className="float-right">-${discountAmount}</span>
      </div>
    </div>
  )
}

export default DiscountComponent
